define(
({
  "alert": "Upozornění",
  "okay": "OK"
})
);
